import { render, staticRenderFns } from "./AppForgotPassword.vue?vue&type=template&id=16b7c767&scoped=true&"
import script from "./AppForgotPassword.vue?vue&type=script&lang=js&"
export * from "./AppForgotPassword.vue?vue&type=script&lang=js&"
import style0 from "./AppForgotPassword.vue?vue&type=style&index=0&id=16b7c767&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b7c767",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VFlex,VLayout})
